/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".weight-qty-wrapper[_ngcontent-%COMP%]{height:100%}.modal-body[_ngcontent-%COMP%]{height:464px;overflow:auto}.attribute[_ngcontent-%COMP%]{padding:10px 5px}.attribute[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;margin-left:-8px;margin-bottom:-11px}.attribute[_ngcontent-%COMP%]   .attribute-title[_ngcontent-%COMP%]{color:#fff;background:#e3a300;text-transform:uppercase;padding:7px;font-weight:700;font-size:.85rem}"];
export { styles as styles };
